// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"GroupedProduct_imageContainer__3o2BJ","labelContainer":"GroupedProduct_labelContainer__19wOR","label":"GroupedProduct_label__3UkwT"};